import React from "react";
import "./css/AboutUs.css";
import pictureOne from "./assets/picOne.png";

const StandardsLevy = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header levy-header">
        <div className="overlay">
          <h1 className="page-title">Standards Levy</h1>
          <p className="subtitle">
            Supporting quality, standardization, and compliance in Malawi through regulatory levies.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About Standards Levy</h2>
          <p>
            The Malawi Bureau of Standards (MBS) administers the Standards Levy, a statutory fee collected 
            to fund standards development, metrology, quality assurance, and regulatory activities. 
            The levy ensures that Malawi maintains high-quality products and services across industries.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Commitment</h2>
          <p>
            Funds from the Standards Levy are used to enhance MBS operations, including certification, 
            testing, verification, and training programs, ensuring Malawi’s products comply with 
            national and international standards.
          </p>
        </div>
      </section>

      {/* === Core Purpose Section === */}
      <section className="functions-section">
        <h2>Purpose of the Standards Levy</h2>
        <ul>
          <li>Funding development and maintenance of national standards.</li>
          <li>Supporting inspection, certification, and compliance programs.</li>
          <li>Enhancing metrology, testing, and calibration services.</li>
          <li>Facilitating industrial research and capacity building.</li>
          <li>Promoting quality assurance and consumer protection.</li>
        </ul>
      </section>

      {/* === Background and Mandate === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            Established in 1972, the Malawi Bureau of Standards (MBS) operates under a statutory framework to ensure 
            quality, standardization, and compliance in Malawi. The Standards Levy is one of the primary instruments 
            that fund its operations.
          </p>

          <h2>Mandate</h2>
          <p>
            To collect, manage, and utilize the Standards Levy to support standardization, certification, testing, 
            inspection, and training services, thereby strengthening Malawi's industrial and commercial sectors.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="Standards Levy Illustration" />
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of the Standards Levy</h2>
        <ul>
          <li>Ensures sustainable funding for MBS services and operations.</li>
          <li>Improves product quality and compliance in industries.</li>
          <li>Supports certification, testing, and calibration programs.</li>
          <li>Promotes consumer protection and fair trade.</li>
          <li>Enhances Malawi’s industrial and economic competitiveness.</li>
        </ul>
      </section>
    </div>
  );
};

export default StandardsLevy;
